export default __webpack_public_path__ + "images/dollar_ab7bbc.svg";